<template>
  <div id="v-html-text">
    <div class="bc-simple-content bc-simple-content-sb" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'HtmlText',
  props: {
    content: { type: String, default: '' },
  },
};
</script>

<style>
/* 여긴 scoped를 먹이면 적용이 안됨. */
#v-html-text p {
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: -0.01px;
  color: #111111;
}

#v-html-text table p {
  font-weight: 400;
  line-height: 1.6;
  letter-spacing: -0.01px;
  color: #494949;
}

#v-html-text table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
}

@media screen and (max-width: 768px) {
  #v-html-text table {
    width: 100%;
    max-width: 100%;
    table-layout: auto;
  }
}

#v-html-text {
  overflow-x: auto;
}
</style>
